module.exports = __webpack_public_path__ + "static/media/dpe3.png.a2afd1c6.jpg";